import React, { useMemo, useState } from 'react';
import '../styles/services.css';
import '../addons-v2/addons-v2.css';
import AddOnCircleCard from '../addons-v2/AddOnCircleCard';
import { useNavigate } from 'react-router-dom';
import ActionButton from '../../../shared/components/action-button/ActionButton';
import { getServicePathSegment } from '../utils/serviceSlug';

const AddOnsPage = ({ service }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortKey, setSortKey] = useState('name_asc');

  const handleAddNew = () => {
    if (!service?.id) return;
    navigate(`/app/overview/services/${getServicePathSegment(service)}/addons/new`);
  };

  const handleEdit = (addOn) => {
    if (!service?.id || !addOn?.id) return;
    navigate(`/app/overview/services/${getServicePathSegment(service)}/addons/${addOn.id}`);
  };

  const visibleAddOns = useMemo(() => {
    const list = Array.isArray(service?.addOns) ? [...service.addOns] : [];
    const q = searchTerm.trim().toLowerCase();
    const filtered = q ? list.filter((a) => String(a?.name || '').toLowerCase().includes(q)) : list;

    const toMs = (v) => {
      const ms = Date.parse(String(v || ''));
      return Number.isFinite(ms) ? ms : 0;
    };

    filtered.sort((a, b) => {
      if (sortKey === 'name_desc') return String(b?.name || '').localeCompare(String(a?.name || ''));
      if (sortKey === 'price_desc') return Number(b?.price || 0) - Number(a?.price || 0);
      if (sortKey === 'updated_desc') return toMs(b?.updatedAt) - toMs(a?.updatedAt);
      return String(a?.name || '').localeCompare(String(b?.name || ''));
    });

    return filtered;
  }, [service?.addOns, searchTerm, sortKey]);

  return (
    <div className="svc-page">
      <div className="ao2-toolbar">
        <div className="ao2-left">
          <input
            className="ao2-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search add-ons…"
            aria-label="Search add-ons"
          />
          <select className="ao2-select" value={sortKey} onChange={(e) => setSortKey(e.target.value)} aria-label="Sort add-ons">
            <option value="name_asc">Sort: Name (A–Z)</option>
            <option value="name_desc">Sort: Name (Z–A)</option>
            <option value="price_desc">Sort: Price (High → Low)</option>
            <option value="updated_desc">Sort: Recently updated</option>
          </select>
        </div>
        <ActionButton variant="primary" onClick={handleAddNew}>
          New Add-on
        </ActionButton>
      </div>

      {visibleAddOns.length === 0 ? (
        <div className="svc-empty">
          <div style={{ fontWeight: 700, marginBottom: 6 }}>No Add-ons Yet</div>
          <div style={{ color: 'var(--text-500)' }}>Start by adding your first service add-on.</div>
        </div>
      ) : (
        <div className="ao2-circleGrid">
          {visibleAddOns.map((addOn) => (
            <AddOnCircleCard key={addOn.id} addOn={addOn} onOpen={() => handleEdit(addOn)} />
          ))}
        </div>
      )}
    </div>
  );
};

export default AddOnsPage; 